import { makeAutoObservable } from 'mobx';
import { CriticalNotificationDto, CriticalNotificationSeverityEnum } from '../../../../defs/api';

export class CriticalNotificationMobxDto implements CriticalNotificationDto {
    id: string;

    severity: CriticalNotificationSeverityEnum;

    text: string;

    activeFrom: Date;

    activeTo: Date;

    createdAt: Date;

    constructor() {
        makeAutoObservable(this);
    }

    static create(dto: CriticalNotificationDto): CriticalNotificationMobxDto {
        const mobxDto = new CriticalNotificationMobxDto();
        return Object.assign(mobxDto, dto);
    }

    static createFromArray(dtos: CriticalNotificationDto[]): CriticalNotificationMobxDto[] {
        return dtos.map((dto) => CriticalNotificationMobxDto.create(dto));
    }

    get isWarning(): boolean {
        return this.severity === CriticalNotificationSeverityEnum.Warning;
    }

    get isCritical(): boolean {
        return this.severity === CriticalNotificationSeverityEnum.Critical;
    }
}
